import { AdditionalMailingRequestOperationsStatus } from "src/store/additionalMailingRequest/types";

export const ADDITIONAL_MAILING_REQUEST_STATUS_LABEL: {
  [key in AdditionalMailingRequestOperationsStatus]: string;
} = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};
